<template>
  <div class="completed-by-container">
    <FriedAvatar :name="fullName" :size="AvatarSize.Small" :thumb-url="thumbUrl" />
    <div class="completed-by-info">
      <FriedH4>{{ t('MAP_completed_by') }}</FriedH4>
      <FriedParagraph :size="ParagraphSize.Small">{{ fullName }}</FriedParagraph>
    </div>
  </div>
</template>
<script lang="ts">
import { AvatarSize, ParagraphSize } from '@getaccept/fried-tofu';
import { useI18n } from 'vue-i18n';
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    fullName: {
      type: String,
      required: true,
    },
    thumbUrl: {
      type: String,
      default: '',
    },
  },
  setup() {
    const { t } = useI18n();
    return {
      ParagraphSize,
      AvatarSize,
      t,
    };
  },
});
</script>
<style lang="scss" scoped>
.completed-by-container {
  display: flex;
  align-items: center;
  gap: var(--spacing-50);
  flex-shrink: 0;

  .heading-4,
  .paragraph {
    color: var(--green-25);
  }

  .paragraph {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 110px;
  }
}
</style>
